import React, { Component } from "react";
import { FormGroup, ControlLabel, FormControl, Radio } from "react-bootstrap";
import "./SignatureForm.css";
import {
  onLocationSelect,
  onNameInput,
  onPositionInput,
  onDepartmentInput,
  onPhoneInput,
  onBrandSelect,
  onSubBrandChoice,
  onMobileNumberInput,
  onEmailInput
} from "../../actions/FormActions";
import { connect } from "react-redux";

class SignatureForm extends Component {
  constructor(props) {
    super(props);

    this.state = {};

    this.locationSelect = this.locationSelect.bind(this);
    this.brandSelect = this.brandSelect.bind(this);
    this.positionInput = this.positionInput.bind(this);
    this.departmentInput = this.departmentInput.bind(this);
    this.nameInput = this.nameInput.bind(this);
    this.phoneInput = this.phoneInput.bind(this);
    this.mobileNumber = this.mobileNumber.bind(this);
    this.emailInput = this.emailInput.bind(this);
  }

  locationSelect(e) {
    this.props.onLocationSelect(e.target.value);
  }

  brandSelect(e) {
    this.props.onBrandSelect(e.target.value);
  }

  positionInput(e) {
    this.props.onPositionInput(e.target.value);
  }

  departmentInput(e) {
    this.props.onDepartmentInput(e.target.value);
  }

  nameInput(e) {
    this.props.onNameInput(e.target.value);
  }

  phoneInput(e) {
    this.props.onPhoneInput(e.target.value);
  }

  mobileNumber(e) {
    this.props.onMobileNumberInput(e.target.value);
  }
  emailInput(e) {
    this.props.onEmailInput(e.target.value);
  }

  render() {
    let mobileNumber = null;
    let departmentSelect = null;
    let positionSelect = null;

    if (this.props.clientFacing === "no") {
      mobileNumber = (
        <FormGroup controlId="mobileNumberField">
          <ControlLabel>Mobile Number</ControlLabel>
          <FormControl
            type="text"
            placeholder="Mobile Number"
            onChange={this.mobileNumber}
          />
        </FormGroup>
      );

      departmentSelect = (
        <FormGroup controlId="departmentField">
          <ControlLabel>Position and Department</ControlLabel>
          <FormControl
            type="text"
            placeholder="Position, Department"
            onChange={this.departmentInput}
          />
        </FormGroup>
      );
    } else {
      positionSelect = (
        <FormGroup controlId="positionField">
          <ControlLabel>Position</ControlLabel>
          <FormControl
            componentClass="select"
            placeholder="select"
            onChange={this.positionInput}
          >
          <option value="Position" disabled selected>
            Position
          </option>
          <option value="Marketing Consultant">Sales</option>
          <option value="Marketing Specialist">Non-Sales</option>
          </FormControl>
        </FormGroup>
      );
    }

    return (
      <div>
        <FormGroup controlId="nameField">
          <ControlLabel>Name</ControlLabel>
          <FormControl
            type="text"
            placeholder="Name"
            onChange={this.nameInput}
          />
        </FormGroup>

        {/* <FormGroup controlId="positionField">
          <ControlLabel>Position</ControlLabel>
          <FormControl
            componentClass="select"
            placeholder="select"
            onChange={this.positionInput}
          >
          <option value="Position" disabled selected>
            Position
          </option>
          <option value="Marketing Consultant">Sales</option>
          <option value="Marketing Specialist">Non-Sales</option>
          </FormControl>
        </FormGroup> */}
        {positionSelect}
        {departmentSelect}

        <FormGroup controlId="phoneField">
          <ControlLabel>Phone </ControlLabel>
          <FormControl
            type="text"
            placeholder="Phone"
            onChange={this.phoneInput}
          />
        </FormGroup>

        {mobileNumber}

        <FormGroup controlId="emailField">
          <ControlLabel>Email</ControlLabel>
          <FormControl
            type="text"
            placeholder="email@web.com"
            onChange={this.emailInput}
          />
        </FormGroup>

        <FormGroup controlId="locationSelect">
          <ControlLabel>Location</ControlLabel>
          <FormControl
            componentClass="select"
            placeholder="select"
            onChange={this.locationSelect}
          >
            <option value="Location" disabled selected>
              Location
            </option>
            <option value="Newfold Digital<br>Teniente General Juan D. Peron 564 | 8th Fl.<br>Capital Federal Buenos Aires C1038AAL">Argentina</option>
            <option value="Newfold Digital<br>245 Peachtree Center Ave. NE | Suite 2000<br>Atlanta GA 30303">Atlanta</option>
            <option value="Newfold Digital<br>12234 N IH 35 | Bldg B Suite 100<br>Austin, TX 78753">Austin</option>
            <option value="Newfold Digital<br>3700 O’Donnell St. Suite 200<br>Columbia, MD 21224">Baltimore</option>
            <option value="Newfold Digital<br>128 Wellington Street West | #205<br>Barrie, ON, Canada L4N 8J6">Barrie</option>
            <option value="Newfold Digital<br>300 Congress St, Ste 301<br>Quincy, MA 02169">Boston</option>
            <option value="Newfold Digital<br>2 Alexandra Gate | Ffordd Pengam<br>Cardiff, CF24 2SA, UK">Cardiff</option>
            <option value="Newfold Digital<br>10101 Claude Freeman Dr. | Suite 210N<br>Charlotte, NC 28262">Charlotte</option>
            <option value="Newfold Digital<br>15720 Brixham Hill Ave | Suite 300<br>Charlotte, NC 28277">Charlotte - Brixham</option>
            <option value="Newfold Digital<br>2 Mid America Plaza | Suite 834<br>Oakbrook Terrace, IL 60181">Chicago</option>
            <option value="Newfold Digital<br>1900 Polaris Parkway | Suite 450<br>Columbus, OH 43240">Columbus</option>
            <option value="Newfold Digital<br>405 State Hwy 121 Bypass | Suite A250<br>Dallas, TX 75067">Dallas</option>
            <option value="Newfold Digital<br>8400 E. Prentice Avenue | Suite 1500<br>Greenwood Village, CO 80111">Denver</option>
            <option value="Newfold Digital<br>10 Azalea Drive<br>Drums, PA 18222">Drums</option>
            <option value="Newfold Digital<br>Suite 1100, 1894 Barrington St Halifax<br>Nova Scotia B3J 2A8 Canada">Halifax</option>
            <option value="Newfold Digital<br>2325 Dulles Corner Blvd | Suite 700<br>Herndon, VA 20171">Herndon</option>
            <option value="Newfold Digital<br>1980 Post Oak Boulevard | Suite 1500<br>Houston, TX 77056">Houston</option>
            <option value="Newfold Digital<br>407 Fulton St.<br>Indianapolis, IN 46202">Indianapolis</option>
            <option value="Newfold Digital<br>5335 Gate Pkwy<br>Jacksonville, FL 32256">Jacksonville</option>
            <option value="Newfold Digital<br>19 Falcon Court | Preston Farm<br>Stockton-On-Tees, TS18 3TU">London</option>
            <option value="Newfold Digital<br>8400 Normandale Lake Blvd. | Suite 920<br>Minneapolis, MN 55437">Minneapolis</option>
            <option value="Newfold Digital<br>610 E River Rd | Suite 0100<br>New Glasgow, NS B2H 3S2, Canada">New Glasgow</option>
            <option value="Newfold Digital<br>999 Riverview Drive | Suite 201<br>Totowa, NJ 07512">New Jersey</option>
            <option value="Newfold Digital<br>215 Celebration Place | Suite 250<br>Celebration, FL 34747">Orlando</option>
            <option value="Newfold Digital<br>House of Metal | Suite 1 901 Pennsylvania Avenue<br>Pittsburgh, PA 15233">Pittsburgh</option>
            <option value="Newfold Digital<br>1800 SW 1st Avenue | Suite 440<br>Portland, OR 97201">Portland</option>
            <option value="Newfold Digital<br>2530 Meridian Parkway | Suite 2097<br>Raleigh-Durham, NC 27713">Raleigh - Durham</option>
            <option value="Newfold Digital<br>18756 Stone Oak Parkway | Suite 200<br>San Antonio, TX 78258">San Antonio</option>
            <option value="Newfold Digital<br>1358 N Scottsdale Rd. | Suite 400<br>Scottsdale, AZ 85257">Scottsdale</option>
            <option value="Newfold Digital<br>17470 N. Pacesetter Way | Suite 201<br>Scottsdale, AZ 85255">Scottsdale - Pacesetter</option>
            <option value="Newfold Digital<br>6100 219th SW| Suite 480<br>Mountain Terrace, WA 98043">Seattle</option>
            <option value="Newfold Digital<br>1425 N Washington<br>Spokane, WA 99201">Spokane</option>
            <option value="Newfold Digital<br>Two City Place Drive | 2nd Floor<br>St. Louis, MO 63141">St Louis</option>
            <option value="Newfold Digital<br>19 Falcon Court | Preston Farm<br>Stockton-On-Tees, TS18 3TU">Stockton</option>
            <option value="Newfold Digital<br>4955 Alton Tucker Blvd. | Suite 300<br>Sugar Hill, GA 30518">Sugar Hill</option>
            <option value="Newfold Digital<br>100 Ashley Drive | Suite 600<br>Tampa, FL 33602">Tampa</option>
            <option value="Newfold Digital<br>1545 Crossways Blvd. |Suite250<br>Chesapeake, VA 23320">Virginia Beach</option>
            <option value="Newfold Digital<br>62 RCOM Drive | Hebron Industrial Park | Yarmouth, Nova Scotia<br>Canada BOW 1XO">Yarmouth</option>
          </FormControl>
        </FormGroup>

      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    location: state.form.location,
    brand: state.form.brand,
    position: state.form.position,
    department: state.form.department,
    name: state.form.name,
    phone: state.form.phone,
    subBrand: state.form.subBrand,
    mobileNumber: state.form.mobileNumber,
    emailInput: state.form.emailInput
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onLocationSelect: value => dispatch(onLocationSelect(value)),
    onBrandSelect: value => dispatch(onBrandSelect(value)),
    onPositionInput: value => dispatch(onPositionInput(value)),
    onDepartmentInput: value => dispatch(onDepartmentInput(value)),
    onNameInput: value => dispatch(onNameInput(value)),
    onPhoneInput: value => dispatch(onPhoneInput(value)),
    onSubBrandChoice: value => dispatch(onSubBrandChoice(value)),
    onMobileNumberInput: value => dispatch(onMobileNumberInput(value)),
    onEmailInput: value => dispatch(onEmailInput(value))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SignatureForm);



// WEBPACK FOOTER //
// ./src/components/SignatureForm/SignatureForm.js